import React from 'react'

import EditBuyerCategoryForm from '../../modules/BuyerCategory/components/EditBuyerCategoryForm'
export default function EditBuyerCategoryPage() {
  return <EditBuyerCategoryForm />
}
